import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsPromptsLoaders } from '../../../_services/alerts.loaders';
import { ApiService } from '../../../_services/api.service';

@Component({
	selector: 'app-expresspay',
	templateUrl: './expresspay.component.html',
	styleUrls: ['./expresspay.component.css']
})
export class ExpresspayComponent implements OnInit {

	Activated:boolean = false;
	token:any = '';
	order_id:any = '';

	payment:any = null;

	constructor(
		private _api: ApiService,
		private route: ActivatedRoute,
		private alertService: AlertsPromptsLoaders
	) { }

	ngOnInit() {
		this.order_id = this.route.snapshot.queryParams['order-id'] || '';
		this.token = this.route.snapshot.queryParams['token'] || '';

		var body = {
			reference_id: this.order_id,
			token: this.token,
		};

		this._api.POST({
			api_route: 'api/payment/v1/job/update',
			body: body,
			load: true,
			success: (data) => {
				this.Activated = true;
				this.payment = data;
				
				console.log('payment Data',data);
				// this.alertService.alertType("Account Activated Successfully",
				// 	'Kindly proceed to login in to your account.', "success");
			},
			error: (error) => {
				console.log('error', error);
			},
			showError: true
		});
	}

}
